import { FaEdit, FaPlusCircle } from "react-icons/fa";

export const tableConstants = (openModal, permissions) => {
  const cols = [
    {
      title: "S.No",
      render: (_, index) => index + 1,
    },

    {
      title: "Class",
      render: (row) => row?.program_name,
    },

    {
      title: "Class Teacher",
      render: (row) => row.teacher?.name || "-",
    },

    {
      title: "Class In Charge",
      render: (row) => row.class_in_charge?.name || "-",
    },

    {
      title: "Commencement Date",
      render: (row) => row.commencement_date || "-",
    },
  ];

  if (permissions?.includes("class.teacher.create")) {
    cols.push({
      title: "Action",

      render: (row) =>
        row.teacher ? (
          <FaEdit
            onClick={() => openModal(row)}
            className="cursor-pointer"
            color="blue"
          />
        ) : (
          <FaPlusCircle
            onClick={() => openModal(row)}
            className="cursor-pointer"
            color="green"
          />
        ),
    });
  }

  return cols;
};
